import { combineReducers } from 'redux';

import auth from './auth';
import data from './data';
import destinationRemarkNames from './destinationRemarkNames';
import destinationLocations from './destinationLocations';
import packingResponses from './packingResponses';

export const reducers = combineReducers({ auth, data, destinationRemarkNames, destinationLocations, packingResponses });
